import { Component, OnInit, HostListener, Input, ViewChild, AfterViewInit } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AppUtilityService } from '../common/app-utility.service';
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
import { DataStoreService } from '../data-store.service';

declare var $: any;
@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
  providers: [DatePipe]
})
export class SignatureComponent implements OnInit, AfterViewInit {
  signatureImg: any = undefined;
  SignatureOnLoad = true;
  ResponseBody: any;
  ServiceBody: FormGroup;
  InitialLoad: boolean;
  private imageSrc: string = '';
  private loaded: boolean = false;
  base64String = [];
  private imageLoaded: boolean = false;
  public uploadedFileExt: String;
  public pdfBytes: String;
  Imagelength: number;
  myDate = new Date();
  myDateTime: string;
  Imagetype: string;
  basevalue: string;
  Applicantname: string;
  ApplicantNRIC: string;
  ApplicantshowOldNRIC: string;
  MandatoryOldNRIC: boolean = false;
  filename: string;
  isEditMode: boolean = false;
  ApplicantList: any;
  NoDisplay: boolean = false;
  DisplayNRIC: string;
  FlowDetails: any;
  showErrors: any = {};
  RefRACE: any;
  showBumi: boolean = false;
  textContent: any;
  onSign: boolean;
  signIcon: string = 'ic-sign';
  uploadIcon: string = 'ic-cloud-upload-white';

  @ViewChild(SignaturePadComponent, {static: false} ) sigPad: SignaturePadComponent;


  constructor(private connect: ConnectRestService, private formBuilder: FormBuilder, public router: Router,
    private datePipe: DatePipe, private activatedRoute: ActivatedRoute, private AppUtility: AppUtilityService, private dataStoreService: DataStoreService) {
      var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
      this.FlowDetails = ServiceHeader.Flow

  }

  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === "oldIC") {
      return this.AppUtility.alphaNumeric(elemValue.key)
    }
  }

  toggleSignatureMode() {
    this.onSign = !this.onSign;
    this.signIcon = this.onSign ? 'ic-sign-white' : 'ic-sign';
    this.uploadIcon = !this.onSign ? 'ic-cloud-upload-white' : 'ic-cloud-upload';
    this.addImage(undefined);
  }

  addImage(image: any) {
    image = image == undefined ? '' : image;
    $('#thumbnail-container-sign').attr("src", image);
    this.signatureImg = image;
    this.uploadedFileExt = 'JPG';
    if (image == '') {
      this.ServiceBody.controls['UploadSignature'].setValidators([Validators.required]);
      this.ServiceBody.controls['UploadSignature'].setValue('');
    } else {
      this.ServiceBody.controls['UploadSignature'].clearValidators();
      this.ServiceBody.controls['UploadSignature'].updateValueAndValidity();
    }
  }

  signImageValidator(invalid) {
    if(invalid) {
      this.ServiceBody.controls['UploadSignature'].setValidators([Validators.required]);
      this.ServiceBody.controls['UploadSignature'].setValue('');
    } else {
      this.ServiceBody.controls['UploadSignature'].clearValidators();
      this.ServiceBody.controls['UploadSignature'].updateValueAndValidity();
    }
  }

  onSubmit() {
    var checkOldIC = false;
    if (!this.MandatoryOldNRIC && this.ApplicantshowOldNRIC) {
      checkOldIC = this.ServiceBody.value.oldIdentificationNumber.length !== 0 && this.ServiceBody.value.oldIdentificationNumber.length < 5;
    } else if (this.MandatoryOldNRIC) {
      checkOldIC = this.ServiceBody.value.oldIdentificationNumber.length < 5;
    }
    if (this.ServiceBody.status == 'VALID' && !checkOldIC) {
      this.callSaveRequest();
    } else {
      this.showErrors['invalidFormat'] = false;
      if (this.ServiceBody.controls.UploadSignature.status !== 'VALID') {
        this.showErrors.UploadSignature = true;
      }
      if (this.ServiceBody.controls.BumiStatus.status !== 'VALID') {
        this.showErrors.BumiStatus = true;
      }
      if (this.ServiceBody.controls.Race.status !== 'VALID') {
        this.showErrors.Race = true;
      }
      if (this.ServiceBody.controls.oldIdentificationNumber.status !== 'VALID') {
        if(this.MandatoryOldNRIC){
          this.showErrors.oldIdentificationNumber = true;
        }     
      } else if (checkOldIC) {
        this.showErrors.oldIdentificationNumberInput = true;
      }  
    }
  }

  onChanges() {
    this.ServiceBody.get('UploadSignature').valueChanges.subscribe(val => {
      if(this.showErrors['UploadSignature']) {
        this.showErrors['UploadSignature'] = false;
      }
    });
    this.ServiceBody.get('oldIdentificationNumber').valueChanges.subscribe(val => {
      if(this.showErrors['oldIdentificationNumber']) {
        this.showErrors['oldIdentificationNumber'] = false;
      }
      if(this.showErrors['oldIdentificationNumberInput']) {
        this.showErrors['oldIdentificationNumberInput'] = false;
      }
    });
    this.ServiceBody.get('BumiStatus').valueChanges.subscribe(val => {
      if(this.showErrors['BumiStatus']) {
        this.showErrors['BumiStatus'] = false;
      }
    });
    this.ServiceBody.get('Race').valueChanges.subscribe(val => {
      if (val == 'Malay' || val == '') {
        this.showBumi = false;
        this.ServiceBody.patchValue({ BumiStatus: 'true'});
        this.ServiceBody.controls.Race.clearValidators();
      } else {
        this.showBumi = true;
        this.ServiceBody.patchValue({ BumiStatus: ''});
        this.ServiceBody.controls.Race.setValidators([Validators.required]);
      }
      if(this.showErrors['Race']) {
        this.showErrors['Race'] = false;
      }
    });
  }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.SignatureScreen : MalayTranslation.SignatureScreen;
    this.RefRACE = JSON.parse(sessionStorage.RefRACE);
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    this.buildForm();
    this.onChanges();
    this.InitialLoad = true;
    this.callReadRequest();
    var platform = this.connect.getPlatformInformation();
    var arrayPlatform = platform.split(' ');
    this.onSign = arrayPlatform[0] && (arrayPlatform[0].toLowerCase() === "ios" || arrayPlatform[0] === 'Android');
    $('#thumbnail-container').addClass("hidden")
  }

  async ngAfterViewInit() {
    if(await this.dataStoreService.getAAStatus()) {
      this.dataStoreService.setAAData('signature');
    }
  }

  onLoad() {
  }

  buildForm() {
    this.ServiceBody = this.formBuilder.group(
      {
        UploadSignature: ['', Validators.required],
        oldIdentificationNumber:[''],
        BumiStatus: ['', Validators.required],
        Race: ['', Validators.required]
      }
    )
  }

  async callSaveRequest() {
    if(this.onSign) {
      this.sigPad.saveSignature();
    }
    this.myDateTime = this.datePipe.transform(this.myDate, 'dd/MM/yyyy h:mm:ss a');
    var CapturedDocumentValue = $('#thumbnail-container-sign').attr('src');
    var data = {
      "ApplicantList": [{
          "Name": this.Applicantname,
          "NRIC": this.ApplicantNRIC,
          "AlternateId": this.ServiceBody.value.oldIdentificationNumber,
          "BumiStatus": this.ServiceBody.controls.BumiStatus.value == 'true' ? 'Bumi' : 'Non-Bumi',
          "Race": this.ServiceBody.controls.Race.value,
          "CapturedDocuments": [{
            "Time": this.myDate,
            "Type": "Signature",
            "Value": CapturedDocumentValue,
            "ExtensionType": this.uploadedFileExt
          }]
      }]
    }
    if(this.ServiceBody.value.oldIdentificationNumber){
      sessionStorage.oldIDNo = this.ServiceBody.value.oldIdentificationNumber
    }
    
    var ServResponse = await this.connect.connectRest(data, "S0090", '');
    if (ServResponse.Status == "Success") {
      if (!this.isEditMode) {
        if (sessionStorage.getItem('constitution') == "C") {
          this.router.navigate(['/company-constitution']);
        } else {
          this.router.navigate(['/declaration']);
        }

      } else {
        this.router.navigate(['/director-confirm']);
      }
    }
    else {
      //   console.log("Server Response: " + ServResponse.Status);
    }
    // console.log(data);
  }

  async callReadRequest() {

    var RequestID = "R0090";
    var data = {};

    var responseData = await this.connect.connectRest(data, RequestID, '');
    this.ApplicantList = responseData ['ApplicantList'];
    this.ApplicantshowOldNRIC = this.ApplicantList[0].ShowOldNRIC;
    if(this.ApplicantList[0].MandatoryOldNRIC == "true"){
      this.MandatoryOldNRIC = true;
    }else {
      this.MandatoryOldNRIC = false;
    }
    if(this.ApplicantshowOldNRIC == "true"){
      this.ServiceBody.controls['oldIdentificationNumber'].setValue(this.ApplicantList[0].AlternateId);     
      // this.ServiceBody.controls['oldIdentificationNumber'].setValidators([Validators.required])
      if(this.MandatoryOldNRIC) {
        this.ServiceBody.controls['oldIdentificationNumber'].setValidators([Validators.required])
      }
    }
    if(this.ApplicantList[0].CapturedDocuments && this.ApplicantList[0].CapturedDocuments[0].Value){
        this.ServiceBody.controls['UploadSignature'].clearValidators();
        this.ServiceBody.controls['UploadSignature'].updateValueAndValidity();
    }
    if (responseData.Status == "Success") {
      this.ResponseBody = responseData;
      
      if (this.ResponseBody.ApplicantList) {
        this.Applicantname = responseData['ApplicantList'][0]['Name'];
        this.ApplicantNRIC = responseData['ApplicantList'][0]['NRIC'];
        this.DisplayNRIC = responseData['ApplicantList'][0]['DisplayNRIC'];
        this.ServiceBody.patchValue({ Race: responseData['ApplicantList'][0]['Race'] });
        if(responseData['ApplicantList'][0]['BumiStatus']) {
          if(responseData['ApplicantList'][0]['Race'] !== "Malay") {
            this.showBumi = true;
          } 
          var bumiStatus = responseData['ApplicantList'][0]['BumiStatus'] == 'Bumi' ? "true" : "false";
          this.ServiceBody.patchValue({ BumiStatus: bumiStatus });
         
          setTimeout(() => {
            if (bumiStatus == "true") {
              $('#BumiStatus_Yes').prop('checked', true);
            } else {
              $('#BumiStatus_No').prop('checked', true);
            }
          }, 300);
        }
        if (responseData['ApplicantList'][0]['CapturedDocuments']) {
          this.InitialLoad = false;
          $('#thumbnail-container-sign').attr('src', responseData['ApplicantList'][0]['CapturedDocuments'][0]['Value']);
          $('#file_text').text("Re-upload");
          // $('#thumbnail-container-sign').css("height","auto");
          $('#thumbnail-container-sign').css({ "height": "auto", "width": "auto", "max-width": "229px", "max-height": "200px" });
          this.uploadedFileExt = responseData['ApplicantList'][0]['CapturedDocuments'][0].ExtensionType;
          $('#thumbnail-container').removeClass("hidden");
          this.signatureImg = responseData['ApplicantList'][0]['CapturedDocuments'][0]['Value'];
        }

      }
    } else {
      // this.ResponseBody = responseData;
      // if (this.ResponseBody.ApplicantList) {
      //   this.Applicantname = this.ResponseBody.ApplicantList.Name;
      //   this.ApplicantNRIC = this.ResponseBody.ApplicantList.NRIC;
      // }
    }
    this.onLoad()
  }

  public disableForm() {
    return ($('#thumbnail-container-sign').attr('src') === '')
  }
  
  validateChar(event){
    var value = event.target.value;
    var control = event.target.getAttribute('formcontrolname');
    if(!this.AppUtility.stringValidation(value)){
      this.ServiceBody.get(control).setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }
  
}
